var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 90,
    viewBox: "0 0 78 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.8889 30.561V23.0864L39.4094 0.760254L0.929825 23.0539V30.5285C0.929825 53.5047 13.1307 74.7259 32.9691 86.2302L39.4094 89.9675L45.8496 86.2302C65.6881 74.7584 77.8889 53.5372 77.8889 30.561Z",
    fill: "#F8B400",
    fillOpacity: 0.37
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1228 45.6301C18.1228 40.171 22.5482 35.7456 28.0073 35.7456H50.4121C55.8711 35.7456 60.2965 40.171 60.2965 45.6301V62.1042C60.2965 67.5632 55.8711 71.9887 50.4121 71.9887H28.0073C22.5482 71.9887 18.1228 67.5632 18.1228 62.1042V45.6301Z",
    stroke: "#028789",
    strokeWidth: 1.97689
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1866 54.841C42.3754 54.0798 43.1635 52.7474 43.1635 51.231C43.1635 48.8654 41.2458 46.9478 38.8802 46.9478C36.5146 46.9478 34.5969 48.8654 34.5969 51.231C34.5969 52.7474 35.3849 54.0798 36.5738 54.841V59.7973C36.5738 61.0711 37.6064 62.1037 38.8802 62.1037C40.154 62.1037 41.1866 61.0711 41.1866 59.7973V54.841Z",
    fill: "#028789"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0073 36.4041V28.4966C28.0073 22.6736 32.7277 17.9531 38.5507 17.9531V17.9531C44.3737 17.9531 49.0941 22.6736 49.0941 28.4966V34.9152",
    stroke: "#028789",
    strokeWidth: 1.97689
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.2e6ab3cc4994655240eceb62be40aa4c.svg";
export { ForwardRef as ReactComponent };